module.exports = __webpack_public_path__ + "static/5-b30ef393cfa315d83e351c3ac918ba35.png";